import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchCurrentBot, fetchCurrentBotSuccess, fetchCurrentBotFailure } from '../../../actions/current-bot.js';
import { selectSubject } from '../../../actions/subject-select.js';
import { isLoading } from '../../../actions/loading.js';
import FormDeleteSubject from  './FormDeleteSubject';

const mapDispatchToProps = (dispatch) => {
    return {
        fetchCurrentBot: (botId) => {
            dispatch(fetchCurrentBot(botId)).then((response) => {
                !response.error ? dispatch(fetchCurrentBotSuccess(response.payload.data)) : dispatch(fetchCurrentBotFailure(response.payload.data));
            });
        },
        setSelectedSubject: bindActionCreators(selectSubject, dispatch),
        loading: bindActionCreators(isLoading, dispatch)
    }
}

export default connect(null, mapDispatchToProps)(FormDeleteSubject);


// WEBPACK FOOTER //
// ./src/redux/components/organisms/FormDeleteSubject/FormDeleteSubjectContainer.js